import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEnumEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchPhasesThunk: any = createAsyncThunk<IBindBaseEnumEntity[]>(
  `${prefix} fetchPhases`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getInstrumentPhases();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch phases. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
